/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D panel
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

const BackgroundPanel = React.forwardRef(({
    width,
    height,
    backgroundColor = "#121212",
    children,
    opacity = "1",
    side = "double",
    title,
    textSizeDecimal,
    textOffset,
    ...otherAttributes
}, ref) => {
    return (
        <a-plane
            ref={ref}
            color={backgroundColor}
            width={width}
            height={height}
            opacity={opacity}
            side={side}
            {...otherAttributes}
        >
            {title && (
                <Text
                    text={title}
                    width={width - (textOffset ? textOffset.x * 2 : 0)}
                    align="left"
                    baseline="top"
                    position={`${
                        -width / 2 + (textOffset ? textOffset.x : 0)
                    } ${height / 2 - (textOffset ? textOffset.y : 0)} ${
                        width / 100
                    }`}
                    sizeDecimal={textSizeDecimal || 25 / height}
                />
            )}
            {children}
        </a-plane>
    )}
);

BackgroundPanel.propTypes = {
    width: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    height: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
};

export default BackgroundPanel;
